import { render, staticRenderFns } from "./SectionRatingComponent.vue?vue&type=template&id=aff03394&scoped=true&"
import script from "./SectionRatingComponent.vue?vue&type=script&lang=js&"
export * from "./SectionRatingComponent.vue?vue&type=script&lang=js&"
import style0 from "./SectionRatingComponent.vue?vue&type=style&index=0&id=aff03394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff03394",
  null
  
)

export default component.exports